import { listarPeriodos } from "../infrastructure/supabase/inventarioPeriodo.repository.js";

export async function obtenerPeriodosUseCase() {
  try {
    const periodos = await listarPeriodos(); // trae todos los registros de la tabla
    if (periodos.length > 0) {
  console.log("[obtenerPeriodosUseCase ] servicio listando Periodos correctamente", periodos);
} else {
  console.warn("⚠ No se encontraron periodos o hubo un error");
}
    // Validamos que sea un array
    if (!Array.isArray(periodos)) {
      console.warn("[obtenerPeriodosUseCase] Response no es array, devolviendo vacío");
      return [];
    }

    return periodos;
  } catch (error) {
    console.error("[obtenerPeriodosUseCase] Error listando periodos:", error.message, error);
    return []; // fallback seguro, evita que el contexto falle
  }
}